import React, { Component } from 'react';
import _ from 'lodash';
import scrollToElement from 'scroll-to-element';
import { Link, Redirect } from 'react-router-dom';

import PoweredByStripe from 'assets/img/powered_by_stripe.png';
import MainHeader, { HeaderText } from 'components/shared/landing/main-header';
import OptionChoiceCard from 'components/shared/plan-card/option-choice-card';
import styles from '../../landing-pages/styles.module.scss';
import LearningCenterDetails from './learning-center-details';
import InstructorCarousel from './instructor-carousel';
import templateStyles from './styles.module.scss';

class ServiceTemplate extends Component {
  constructor(props) {
    super(props);

    const { selectedLearningCenterId } = this.props;

    this.state = {
      learningCenterId: selectedLearningCenterId,
      redirectToCheckout: false,
      purchasedPlan: false,
      selectedOptions: {},
    };

    this.startPlanPurchase = this.startPlanPurchase.bind(this);
    this.onSelectLearningCenter = this.onSelectLearningCenter.bind(this);
    this.onViewCenter = this.onViewCenter.bind(this);
  }

  // TODO: After reviewing the options below, I think the `if` chain can be heavily refactored. -AW
  startPlanPurchase() {
    const {
      checkoutPath,
      learningCenters,
      plan,
      selectedLearningCenterId,
      history,
    } = this.props;
    const { learningCenterId, selectedOptions } = this.state;
    if (
      plan.options &&
      plan.options.length > 0 &&
      plan.options.length !== _.keys(selectedOptions).length
    ) {
      // We need to select options still
      scrollToElement('#service-options');
    } else if (learningCenters.length === 1) {
      // There's only one center, so select it for them
      const learningCenter = learningCenters[0];
      history.push({
        pathname: checkoutPath,
        state: { learningCenter, service: plan, selectedOptions },
      });
    } else if (selectedLearningCenterId) {
      // This is a special, center-specific marketing url, select it for them
      const learningCenter = _.find(learningCenters, [
        'id',
        parseInt(selectedLearningCenterId, 10),
      ]);
      history.push({
        pathname: checkoutPath,
        state: { learningCenter, service: plan, selectedOptions },
      });
    } else if (learningCenterId) {
      // They've already selected a center and probably forgot to select options until now.
      const learningCenter = _.find(learningCenters, ['id', learningCenterId]);
      history.push({
        pathname: checkoutPath,
        state: { learningCenter, service: plan, selectedOptions },
      });
    } else {
      // Make them select a center
      scrollToElement('#learning-centers');
    }
  }

  onSelectLearningCenter(learningCenterId) {
    return () => {
      const { plan } = this.props;
      const { selectedOptions } = this.state;
      if (
        plan.options &&
        plan.options.length > 0 &&
        plan.options.length !== _.keys(selectedOptions).length
      ) {
        this.setState({ viewCenterDetailsFor: null }, () =>
          scrollToElement('#service-options'),
        );
      } else {
        this.setState({ redirectToCheckout: true, learningCenterId });
      }
    };
  }

  onSelectOption(optionId, choiceId) {
    return () => {
      this.setState(prevState => {
        const { learningCenters, plan } = this.props;
        const selectedOptions = { ...prevState.selectedOptions };
        selectedOptions[optionId] = choiceId;
        if (plan.options.length === _.keys(selectedOptions).length) {
          if (learningCenters.length === 1) {
            return {
              ...prevState,
              selectedOptions,
              learningCenterId: learningCenters[0].id,
              redirectToCheckout: true,
            };
          }
          scrollToElement('#learning-centers');
          return { ...prevState, selectedOptions };
        }
        return { ...prevState, selectedOptions };
      });
    };
  }

  onViewCenter(centerId) {
    return () => {
      this.setState({ viewCenterDetailsFor: centerId });
    };
  }

  render() {
    const {
      learningCenterId,
      redirectToCheckout,
      selectedOptions,
      viewCenterDetailsFor,
    } = this.state;

    const { plan, selectedLearningCenterId, checkoutPath } = this.props;
    let { learningCenters } = this.props;

    if (!plan || !learningCenters) {
      return <div />;
    }

    const selectedLearningCenter = _.find(learningCenters, [
      'id',
      learningCenterId,
    ]);

    if (selectedLearningCenterId) {
      learningCenters = _.filter(learningCenters, [
        'id',
        parseInt(selectedLearningCenterId, 10),
      ]);
    }

    return (
      <div className={templateStyles.templateContainer}>
        {redirectToCheckout && (
          <Redirect
            to={{
              pathname: checkoutPath,
              state: {
                learningCenter: selectedLearningCenter,
                service: plan,
                selectedOptions,
              },
            }}
          />
        )}
        <MainHeader
          style={styles.astronautValueProp}
          header={
            <HeaderText className={styles.headerText}>{plan.title}</HeaderText>
          }
          subtext={plan.instructor_intro}
          onButtonClick={this.startPlanPurchase}
          buttonText="Sign Up"
          buttonClassName="apple"
          image={plan.image_file_name}
          flip
        />
        {plan.quantity_remaining && (
          <section className={templateStyles.limitedQuantity}>
            <div className={styles.container}>
              <div className={styles.row}>
                <div className="col-12">
                  <h2>Only {plan.quantity_remaining} spots left!</h2>
                </div>
              </div>
            </div>
          </section>
        )}
        <section className={styles.aboutCourse}>
          <div className={styles.container}>
            {plan.target_audience && (
              <div className={styles.row}>
                <div className={styles.tldrColumn}>
                  <h2>Who Benefits</h2>
                </div>
                <div
                  className={styles.mainColumn}
                  dangerouslySetInnerHTML={{ __html: plan.target_audience }}
                />
              </div>
            )}
            {plan.preset_dates && (
              <div className={styles.row}>
                <div className={styles.tldrColumn}>
                  <h2>When</h2>
                </div>
                <div
                  className={styles.mainColumn}
                  dangerouslySetInnerHTML={{ __html: plan.preset_dates }}
                />
              </div>
            )}
            <div className={styles.row}>
              <div className={styles.tldrColumn}>
                <h2>Description</h2>
              </div>
              <div
                className={styles.mainColumn}
                dangerouslySetInnerHTML={{ __html: plan.description }}
              />
            </div>
            <div className={styles.contactRow}>
              <button
                type="button"
                onClick={() => this.startPlanPurchase()}
                className={styles.contactInstructorGreen}
              >
                Get Started
              </button>
            </div>
          </div>
        </section>
        {plan.options && plan.options.length > 0 && (
          <section
            id="service-options"
            className={templateStyles.serviceOptions}
          >
            <div className={styles.container}>
              {plan.options.map(option => (
                <div key={option.id} className={styles.row}>
                  <div className="col-12">
                    <h3 className="font-heavy">1. Choose {option.name}</h3>
                    <div className={templateStyles.horizontalScrolly}>
                      {option.choices.map(choice => (
                        <OptionChoiceCard
                          key={choice.id}
                          choice={choice}
                          onSelect={this.onSelectOption(option.id, choice.id)}
                          selected={selectedOptions[option.id] === choice.id}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}
        <section
          className={templateStyles.learningCenterContainer}
          id="learning-centers"
        >
          <div className={styles.container}>
            <div className={styles.row}>
              <div className="col-12">
                <h3 className="font-heavy">
                  {(plan.options && plan.options.length) > 0 && '2.'}
                  &nbsp;Choose Educator
                </h3>
                <InstructorCarousel
                  learningCenters={learningCenters}
                  onViewMore={this.onViewCenter}
                  onSelect={this.onSelectLearningCenter}
                />
              </div>
            </div>
          </div>
        </section>
        <section className={styles.reminders}>
          <div className={styles.container}>
            <div className={styles.row}>
              <div className={styles.tldrColumn}>
                <h2>Reminders</h2>
              </div>
              <div className={styles.mainColumn}>
                <h3>Device &amp; Internet</h3>
                <p>
                  Since instruction takes place primarily using{' '}
                  <Link to="/online-platform">Unyted's Online Platform</Link>,
                  learners will need some sort of device capable of runnning a
                  modern web browser and an internet connection. You can use a
                  phone, tablet, or laptop!
                </p>
                <h3>First session onboarding </h3>
                <p>
                  Each learner will be given an onboarding session to meet
                  educator and get introduced to TEAM Method. These *may* be
                  included in educators' programs. For 1 on 1 sessions, they'll
                  need to be scheduled by the parent.
                </p>
                <h3>
                  Secure Payments
                  <a href="https://stripe.com" target="_blank" rel="noreferrer">
                    <img
                      className="ml-3"
                      src={PoweredByStripe}
                      alt="Powered by Stripe"
                    />
                  </a>
                </h3>
                <p>
                  All payments are processed by our partner, Stripe. Stripe is a
                  secure payment platform using the same industry-standard
                  security and encryption you're used to!
                </p>
              </div>
            </div>
          </div>
        </section>
        {viewCenterDetailsFor && (
          <LearningCenterDetails
            learningCenter={_.find(learningCenters, [
              'id',
              viewCenterDetailsFor,
            ])}
            onClose={this.onViewCenter(null)}
            plan={plan}
            onSelectLearningCenter={this.onSelectLearningCenter(
              viewCenterDetailsFor,
            )}
          />
        )}
      </div>
    );
  }
}

export default ServiceTemplate;
